import debounce from "../helpers/debounce";

class Header {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.body = document.body;
        self.headerHeight = 0;
    }

    init() {
        let self = this;

        // On page load...
        window.addEventListener('load', evt => {
            // Set header height property on page load
            self.setHeightProperty();

            // Set header shrunk state on page load
            self.setShrunkState();

            // Set header shrunk state on scroll
            window.addEventListener("scroll", () => {
                self.setShrunkState();
            });
        }, false);

        // Set header height property on window resize
        let debouncedFunction = debounce(function () {
            // Wait a bit for CSS transitions to finish (yeah, bit gross 🤷‍♂️)
            setTimeout(() => {
                self.setHeightProperty();
            }, 400);
        });

        window.addEventListener('resize', function () {
            debouncedFunction();
        }, false);
    }

    setShrunkState(lastScroll) {
        let self = this;

        // If the page is scrolled down
        if(window.pageYOffset > self.headerHeight) {
            self.elem.classList.add('is-shrunk');
        } else {
            self.elem.classList.remove('is-shrunk');
        }

    }

    setHeightProperty() {
        let self = this;

        self.headerHeight = self.elem.offsetHeight;

        document.documentElement.style.setProperty("--header-height", self.headerHeight + 'px');
    }
}

export default Header;
